export function firstUserContent(messages) {
  const firstUser = messages.find((message) => message.role === 'user')
  return String(firstUser?.content || 'New conversation').trim()
}

export function lastUserContent(messages) {
  const users = messages.filter((message) => message.role === 'user')
  return String(users.at(-1)?.content || '').trim()
}

export function titleFromMessages(messages) {
  const title = firstUserContent(messages).replace(/\s+/g, ' ')
  return title.length > 80 ? `${title.slice(0, 80)}…` : title
}
